var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { SystemIconBase } from './styled';
export function SystemIcon(_a) {
    var { name, children, color, size = 24 } = _a, props = __rest(_a, ["name", "children", "color", "size"]);
    const hasLabel = Boolean(props.title || props['aria-label'] || props['aria-labelledby']);
    return (React.createElement(SystemIconBase, Object.assign({}, props, { color: color, size: size, 
        // Need to use role="img" for the screen reader to
        // interpret the component as an image and therefore
        // read the alternative label.
        role: hasLabel ? 'img' : undefined, "aria-hidden": !hasLabel, translate: "no" }), name || children));
}
export default SystemIcon;
